import { useMemo } from 'react';
import { renderInlineMarks } from '../lib/markdown.js';

interface Props {
  /** Texto crudo del usuario, con marcas `**bold**` y `_italic_`. */
  text: string;
  /**
   * Clases tailwind para el wrapper. Por defecto se renderiza con
   * `whitespace-pre-line` para preservar los saltos de línea del input —
   * los consumers existentes ya dependían de eso.
   */
  className?: string;
  as?: 'p' | 'div';
}

/**
 * Render seguro de descripciones cortas con marcas inline.
 *
 * `renderInlineMarks` escapa HTML antes de aplicar las regex de marca, así
 * que el HTML resultante solo contiene `<strong>` y `<em>`. Eso hace que
 * `dangerouslySetInnerHTML` sea seguro acá — la "peligrosidad" del API
 * depende de qué le metas adentro, no del API en sí.
 */
export function RichText({ text, className, as = 'div' }: Props) {
  const html = useMemo(() => renderInlineMarks(text), [text]);
  const Tag = as;
  return (
    <Tag
      className={['whitespace-pre-line', className ?? ''].join(' ')}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
